<template>
  <div :style="{cursor, userSelect, 'min-height': `${minHeight}px`}"
       class="vue-splitter-container clearfix"
       @mouseup="onMouseUp"
       @mousemove="onMouseMove">
    <panel class="splitter-pane splitter-paneL" :split="split" :style="{ [type]: percent+'%'}">
      <q-resize-observable @resize="onLeftResize" v-if="elementSize"></q-resize-observable>

      <slot name="panel-left"
            :table-height="leftTableHeight"></slot>
    </panel>

    <resizer :className="className"
             :style="{ [resizeType]: percent+'%'}"
             :split="split"
             @mousedown.native="onMouseDown"
             @dblclick.native="onDblClick"></resizer>

    <panel class="splitter-pane splitter-paneR" :split="split" :style="{ [type]: 100-percent+'%'}">
      <q-resize-observable @resize="onRightResize" v-if="elementSize"></q-resize-observable>

      <slot name="panel-right"
            :table-height="rightTableHeight"></slot>
    </panel>
  </div>
</template>

<script>
  import Resizer from './PanelResizer'
  import Panel from './Panel'

  export default {
    name: 'SplitterPanel',
    components: {
      Resizer,
      Panel
    },
    props: {
      resizePercent: {
        type: Number,
        default: 50
      },
      minHeight: {
        type: Number,
        default: 0
      },
      minPercent: {
        type: Number,
        default: 10
      },
      maxPercent: {
        type: Number,
        default: 100
      },
      defaultPercent: {
        type: Number,
        default: 50
      },
      split: {
        validator (value) {
          return ['vertical', 'horizontal'].indexOf(value) >= 0
        },
        required: true
      },
      reverse: {
        type: Boolean,
        default: false
      },
      leftPageMargin: {
        type: Number,
        default: 30
      },
      rightPageMargin: {
        type: Number,
        default: 30
      },
      elementSize: {
        type: Boolean,
        default: true
      },
      className: String,
      // TAMS
      // True 시, Resize Mode(reverse: false)에서 클릭 시 resizePercent, defaultPercent에 따라 토글됨.
      resizeHideToggle: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        active: false,
        hasMoved: false,
        clicked: false,
        height: null,
        leftTableHeight: void 0,
        rightTableHeight: void 0,
        percent: this.defaultPercent,
        type: this.split === 'vertical' ? 'width' : 'height',
        resizeType: this.split === 'vertical' ? 'left' : 'top'
      }
    },
    computed: {
      userSelect () {
        return this.active ? 'none' : ''
      },
      cursor () {
        return this.active ? 'col-resize' : ''
      }
    },
    methods: {
      onLeftResize (size) {
        this.leftTableHeight = size.height - this.leftPageMargin
      },
      onRightResize (size) {
        this.rightTableHeight = size.height - this.rightPageMargin
      },
      onDblClick () {
        if (!this.reverse && !this.hasMoved) {
          if (this.resizeHideToggle) {
            this.percent = this.clicked ? this.defaultPercent : this.resizePercent
            this.clicked = !this.clicked
          } else {
            this.percent = this.resizePercent
          }
          this.$emit('resize', { clicked: this.clicked })
        } else if (this.reverse) {
          this.percent = this.clicked ? this.defaultPercent : this.resizePercent
          this.clicked = !this.clicked
          this.$emit('resize', { clicked: this.clicked })
        }
        this.$emit('dblclick', this.clicked)
      },
      onMouseDown () {
        this.active = true
        this.hasMoved = false
      },
      onMouseUp () {
        this.active = false
      },
      onMouseMove (e) {
        if (this.reverse || this.clicked) {
          return
        }

        if (e.buttons === 0 || e.which === 0) {
          this.active = false
        }

        if (this.active) {
          let offset = 0
          let target = e.currentTarget

          if (this.split === 'vertical') {
            while (target) {
              offset += target.offsetLeft
              target = target.offsetParent
            }
          } else {
            while (target) {
              offset += target.offsetTop
              target = target.offsetParent
            }
          }

          const currentPage = this.split === 'vertical' ? e.pageX : e.pageY
          const targetOffset = this.split === 'vertical' ? e.currentTarget.offsetWidth : e.currentTarget.offsetHeight
          const percent = Math.floor(((currentPage - offset) / targetOffset) * 10000) / 100

          if (percent > this.minPercent && (percent < 100 - this.minPercent && percent <= this.maxPercent)) {
            this.percent = percent
          }

          this.$emit('resize', this.percent)
          this.hasMoved = true
        }
      }
    }
  }
</script>
